



















import { defineComponent, ref, PropType, toRefs, computed } from '@vue/composition-api';
import { Validator } from '@tt4b/ttam-hooks';
import { CampaignFormData, AdgroupFormData, MessageEventSetItem } from '@tt4b/ttam-enums';
import TtamMessageEventSet from './index';

const name = 'ttam-message-event-set-compose';
export default defineComponent({
  name,
  components: {
    TtamMessageEventSetList: TtamMessageEventSet.TtamMessageEventSetList,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    validator: {
      type: Array as PropType<Validator>,
      default: () => [],
    },
    list: {
      type: Array as PropType<MessageEventSetItem[]>,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { adgroupData } = toRefs(props);
    const messageEventSetRef = ref();
    const _adRefMessageEventSetId = computed(() => adgroupData.value.adRefMessageEventSetId);
    const handleChange = (i: MessageEventSetItem) => {
      emit('change', i);
    };
    const handleAdd = () => {
      emit('add');
    };
    const handleRefresh = () => {
      emit('refresh');
    };

    return {
      name,
      _adRefMessageEventSetId,
      messageEventSetRef,
      handleChange,
      handleAdd,
      handleRefresh,
    };
  },
});
